<template>
  <div>
    <van-skeleton title animate :row="12" :loading="loading_ske">
      <div class="titles">
        公司列表
        <!--        <Button type="info" shape="circle" class="role01" size="small" icon="ios-add" @click="del">添加</Button>-->
      </div>
      <div class="company1" v-if="user.companyId == 1">
        <div class="company2" @click="chaungjian">
          <img src="@/assets/imgs/28.png" class="imgg" alt="">
          <div>创建公司</div>
        </div>
      </div>
      <Table border ref="selection" :columns="columns7" :data="data6" :loading="loading"></Table>
      <div class="role02">
        <Page :total="total" @on-change="nextPage"/>
      </div>
    </van-skeleton>
    <xc-model :loading="createCompany" :round="false" title="创建公司" :is_buttom="false" @cancel="xgcancel">
      <div slot="mbody">
        <div class="company3">
          <div class="company4">
            <div class="company5">账<span class="spnis">号</span>：</div>
            <input v-model="mobile" type="number" maxlength="11" placeholder="请输入手机号" class="company6">
          </div>
          <div class="company4" style="margin-top: 20px">
            <div class="company5">姓<span class="spnis">名</span>：</div>
            <input v-model="username" type="text" placeholder="请输入姓名" class="company6">
          </div>
          <div class="company4" style="margin-top: 20px">
            <div class="company5">公司名称：</div>
            <input v-model="companyname" type="text" placeholder="请输入公司名称" class="company6">
          </div>
          <div class="company4" style="margin-top: 20px">
            <div class="company5" style="margin-top: 15px;">营业执照：</div>
            <div class="bpk02g2" style="position: relative">
              <img src="@/assets/images/qw3.png" class="bpk03" alt="" v-if="imageUrls == ''">
              <img :src="imageUrls" class="bpk03" alt="" v-else>
              <Upload
                class="bpk04o4s"
                :on-success="succGzs"
                :multiple="false"
                type="drag"
                action="/load/gyy/api/uploadfile">
                <div>
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或者拖拽以上传图片</p>
                </div>
              </Upload>
            </div>
          </div>
          <div class="company7">
            <div class="company8" @click="baocun()">保存</div>
            <div class="company8" style="margin-left: 30px" @click="xgcancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
  </div>
</template>

<script>
  import httpCom from '@/api/Com';
  import util from '@/util/util';
  export default {
    name: "comList",
    data() {
      return {
        createCompany:false,
        mobile:'',
        username:'',
        user:'',
        companyname:'',
        imageUrls:'',
        columns7: [
          {
            title: '公司名称',
            key: 'name',
            render: (h, params) => {
              return h('div', [
                h('Icon', {
                  props: {
                    type: 'person'
                  }
                }),
                h('strong', params.row.name)
              ]);
            }
          },
          {
            title: '管理员',
            key: 'userName'
          },
          {
            title: '审核状态',
            key: 'shStatus'
          },
          {
            title: '创建时间',
            key: 'ctime'
          },
        ],
        data6: [],
        loading_ske:true,     //骨架屏显示
        page:1,               //页数
        pageSize:10,          //显示条数
        total:0,              //列表总数
        loading:false,        //是否加载
      }
    },
    mounted() {
      var me = this;
      let user = JSON.parse(sessionStorage.getItem('user'));
      me.user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        state:1,
        mobile:user.mobile,
        sign:user.sign,
        page:me.page,
        pageSize:me.pageSize,
        companyId:user.companyId
      }
      if (user.companyId == 1) {
        data.companyId = '';
      }
      httpCom.list(data).then(res => {
        console.log(res);
        me.data6 = res.data.dataList;
        me.data6.forEach(function (item,index) {
          me.$set(item,'shStatus','已审核');
        })
        me.total = res.data.totalNum;
        me.loading_ske = false;
      })
    },
    methods:{
      chaungjian(){
        var me = this;
        me.createCompany = true
      },
      baocun(){
        var me = this;
        me.loading = true;
        if (me.mobile == ''  || util.noBq().test(me.mobile)) {
          me.$message.error('账号不能为空并不能含有表情');
          return false;
        }
        if (me.username == ''  || util.noBq().test(me.username)) {
          me.$message.error('姓名不能为空并不能含有表情');
          return false;
        }
        if (me.companyname == ''  || util.noBq().test(me.companyname)) {
          me.$message.error('公司名称不能为空并不能含有表情');
          return false;
        }
        if (me.imageUrls == '') {
          me.$message.error('营业执照不能为空');
          return false;
        }
        let data = {
          mobile:me.mobile,
          username:me.username,
          password:'123456',
          imgbase64:me.imageUrls,
          companyname:me.companyname,
          userid:me.user.userId
        }
        httpCom.companyadd(data).then(res=>{
          if(res.code == '0000'){
            me.$message.success('创建成功')
            me.loading = false;
            me.loading_ske = false;
            me.createCompany = false
          }else if(res.code == '1111'){
            me.$message.error('创建失败')
            me.loading = false;
            me.loading_ske = false;
          }else if(res.code == '1002'){
            me.$message.error('手机号已存在')
            me.loading = false;
            me.loading_ske = false;
          }
        })
      },
      xgcancel(){
        var me = this;
        me.mobile = '';
        me.username = '';
        me.companyname = '';
        me.imageUrls = ''
        me.createCompany = false
      },
      succGzs(e){
        var me = this;
        me.imageUrls = e.data;
        console.log(e,"ddd");
      },
      nextPage(e){//下一页
        var me = this;
        me.loading = true;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          state:1,
          mobile:user.mobile,
          sign:user.sign,
          page:e,
          pageSize:me.pageSize,
          companyId:user.companyId
        }
        if (user.companyId == 1) {
          data.companyId = '';
        }
        httpCom.list(data).then(res => {
          console.log(res);
          me.data6 = res.data.dataList;
          me.data6.forEach(function (item,index) {
            me.$set(item,'shStatus','已审核');
          })
          me.loading = false;
        })
      }
    }
  }
</script>

<style scoped>
@import "company.css";
</style>